import { Locale, type LocalizedString } from "../Locale.js";
import { SoldOutLabel } from "../SoldOutLabel.js";

export const soldOutLabelNameMap = {
	[SoldOutLabel.Unavailable]: {
		[Locale.cs]: "Aktuálně nedostupné",
	},
	[SoldOutLabel.SoldOut]: {
		[Locale.cs]: "Aktuálně vyprodáno",
	},
	[SoldOutLabel.UnavailableOnEshop]: {
		[Locale.cs]: "Aktuálně nedostupné na e-shopu",
	},
	[SoldOutLabel.SoldOutOnEshop]: {
		[Locale.cs]: "Aktuálně vyprodáno na e-shopu",
	},
} satisfies Record<SoldOutLabel, LocalizedString>;
